import Repository from '../repository';

const resource = '/product';

export default {
  get(params) {
    return Repository.get(`${resource}`, { params });
  },
  getBySlug(slug, params = {}) {
    return Repository.get(`${resource}/${slug}`, { params });
  },
  getByVariants(slug, params = {}) {
    return Repository.get(`${resource}/${slug}/variants`, { params });
  },
  search(params) {
    return Repository.get(`${resource}/search`, { params });
  },
  getFilters(data) {
    return Repository.post(`${resource}/filters`, data);
  },
  getStock(slug, data = {}) {
    return Repository.get(`${resource}/${slug}/stock`, data);
  }
};
